<template>
    <BreadCrumb PageTitle="Ajout d'un inventaire" />
    <AddInventaire />
</template>

<script lang="ts">
    import { defineComponent } from "vue";

    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import AddInventaire from "@/components/Inventaire/AddInventaire.vue";

    export default defineComponent({
        name: "AddInventairePage",
        components: {
            BreadCrumb,
            AddInventaire,
        },
    });
</script>